module.exports = __webpack_public_path__ + "img/btn_play@3x.68f47915.png";